document.addEventListener('DOMContentLoaded', function () {
    const openBtn = document.querySelector('.product-label__form--button');
    const popup = document.getElementById('redemption-popup');
    const closeBtn = document.getElementById('popup-close');
    const toast = document.getElementById('success-toast');

    function closePopup() {
        popup.style.visibility = 'hidden';
    }

    function showToast() {
        if (!toast) return;
        toast.classList.add('show');
        setTimeout(() => {
            toast.classList.remove('show');
            toast.style.display = 'flex';
        }, 3000);
    }

    if (openBtn && popup && closeBtn) {
        openBtn.addEventListener('click', function () {
            popup.style.visibility = 'visible';
        });

        closeBtn.addEventListener('click', closePopup);

        popup.addEventListener('click', function (e) {
            if (e.target === popup || e.target.classList.contains('redemption-popup__overlay')) {
                closePopup();
            }
        });
    }

    // Listen for messages from iframe
    window.addEventListener('message', function (event) {
        if (event.data.event === 'webFormSubmission' && event.data.status === 'success') {
            closePopup();
            toast.style.display = 'flex';
            showToast();
        }
    });
});
